<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'text',
  },
  name: {
    type: String,
    required: true,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  validation: {
    type: [Array, String],
    default: () => [],
  },
  validationVisibility: {
    type: String,
    default: 'blur', // or 'submit'
  },
  validationMessages: {
    type: Object,
    default: () => ({}),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  delay: {
    type: String,
    default: '250',
  },
  licensePlate: {
    type: Boolean,
    default: false,
  },
  uppercase: {
    type: Boolean,
    default: false,
  },
});

// eslint-disable-next-line no-undef
const baseUrl = publicPath + modulePath || import.meta.env.VITE_BASE_URL;
const imageBind = computed(() => {
  return props.licensePlate ? `url(  ${baseUrl}/svg/nl.svg)` : null;
});
</script>

<template>
  <FormKit
    :type="type"
    :name="name"
    :label="label"
    :validation="validation"
    :validation-visibility="validationVisibility"
    :validation-messages="validationMessages"
    :placeholder="placeholder"
    :classes="{
      inner: {
        $reset: licensePlate,
      },
      input: {
        'input--license-plate': licensePlate,
        'uppercase': uppercase,
        'input-label': true,
      },
    }"
    :disabled="disabled"
    :delay="delay"
  />
</template>

<style lang="scss">
.input--license-plate {
  background-image: v-bind(imageBind);
}

.uppercase {
  text-transform: uppercase;
}
</style>
